export function parseWorkoutNumber(raw: string, min: number, max: number, integer = false): number | null {
  const normalized = raw.trim().replace(',', '.');
  if (!(integer ? /^\d+$/ : /^\d+(?:\.\d*)?$/).test(normalized)) return null;
  const value = Number(normalized);
  return Number.isFinite(value) && value >= min && value <= max && (!integer || Number.isInteger(value)) ? value : null;
}

